import React from 'react';
import { Text, Modal, Button } from '@rsos/components/capstone/base';
import {
  ModalBody,
  ModalHeader,
  ModalFooter,
} from '@rsos/components/capstone/base/Modal/ModalComponents';

const DeleteCidrModal = ({ isOpened, onClose, handleDelete, deleting }) => {
  return (
    <Modal
      isOpened={isOpened}
      onClose={onClose}
      width={350}
      id="modal-delete-cidr"
    >
      <ModalHeader onClose={onClose}>
        <Text
          size="xlarge"
          fontWeight="semibold"
          color=" secondaryText"
          mb={15}
        >
          Delete IP Access Restriction?
        </Text>
      </ModalHeader>
      <ModalBody>
        <Text size="small" color="secondaryText">
          Are you sure you want to delete this control? Deleting this control
          will allow users to log in outside of the agency and/or outside of the
          specified IP address/s. If this is temporary, consider pausing the
          restriction on the specified IP address instead.
        </Text>
      </ModalBody>
      <ModalFooter flow={12} justify="center">
        <Button
          btnType="primary"
          onClick={handleDelete}
          grow
          isLoadingProp={deleting}
        >
          Confirm
        </Button>
        <Button btnType="tertiary" grow onClick={onClose}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default DeleteCidrModal;
